import { FC } from 'react';

import { useTranslations } from 'context/translations';
import { LandingPageImageKeys, LandingPageTextKeys } from 'service';
import { useMediaQuery } from 'hooks';

import styles from './WhatIsUpBlock.module.css';

export const WhatIsUpBlock: FC = () => {
  const { image, t } = useTranslations();
  const isMobile = useMediaQuery('(max-width: 905px)');
  const imageHeight = isMobile ? 588 : 644;

  return (
    <div className={styles.container}>
      <h1>{t(LandingPageTextKeys.WhatUpBlockTitle)}</h1>
      <div className={styles.content}>
        <div className={styles.block}>
          <div className={styles.block_wrapper_image}>
            <img
              className={styles.block_image}
              src={image(LandingPageImageKeys.WhatUpBlockCard0Image, {
                h: imageHeight,
              })}
              alt="image_item_0"
              loading="lazy"
            />
          </div>
          <div className={styles.block_header}>
            <h2>{t(LandingPageTextKeys.WhatUpBlockCard0Title)}</h2>
            <div>{t(LandingPageTextKeys.WhatUpBlockCard0Description)}</div>
          </div>
        </div>
        <div className={styles.block}>
          <div className={styles.block_wrapper_image}>
            <img
              className={styles.block_image}
              src={image(LandingPageImageKeys.WhatUpBlockCard1Image, {
                h: imageHeight,
              })}
              alt="image_item_1"
              loading="lazy"
            />
          </div>
          <div className={styles.block_header}>
            <h2>{t(LandingPageTextKeys.WhatUpBlockCard1Title)}</h2>
            <div>{t(LandingPageTextKeys.WhatUpBlockCard1Description)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
